import { render, staticRenderFns } from "./voteManager.vue?vue&type=template&id=1787424b&"
import script from "./voteManager.vue?vue&type=script&lang=js&"
export * from "./voteManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports